export enum RiskLevel {
  Low = "Low",
  Moderate = "Moderate",
  High = "High",
  Unknown = "Unknown",
}
